import { Input, useEmailValidation } from '@landsbankinn/ui';
import React from 'react';

interface IProps {
  email: string;
  setEmail: (email: string) => void;
  label?: string;
}

export function Email({ email, setEmail, label }: IProps) {
  const [ref, isValid, message] = useEmailValidation(email);

  return (
    <Input
      inputRef={ref}
      isValid={isValid}
      errorMessage={message}
      label={label ?? 'Netfang'}
      value={email}
      onChange={(event) => setEmail(event.target.value)}
      id="fea"
      variant="noBorder"
      labelVariant="aboveInput"
    />
  );
}
